import { ofType } from "redux-observable";
import { combineChecks } from "../../guards/combineChecks";
import { guard } from "../../guards/guard";
import { pathEmpty } from "../../guards/pathEmpty";
import { TypeActionTutorial } from "../actionTutorial";
import { checkTutorialHarvestClickAcre } from "../checks/checkTutorialHarvestClickAcre";
import { checkTutorialNextStepConfigExists } from "../checks/checkTutorialNextStepConfigExists";
import { pathTutorialUpdateViewport } from "../path/pathTutorialUpdateViewport";
export var epicTutorialHarvest = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTutorial.HarvestClickAcre), guard(state$, deps, pathEmpty)([
        combineChecks([checkTutorialNextStepConfigExists, checkTutorialHarvestClickAcre])(pathTutorialUpdateViewport),
    ]));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/epics/epicTutorialHarvest.ts
// module id = 2466
// module chunks = 3